export default "__VITE_ASSET__8b6f4754__"